import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LeafletMap from "./LeafletMap";
import { Descriptions } from "antd";
import moment from "moment";
import { cashConverter, formatPath, previewPaper } from "../../../../utils";

function AboutScheme() {
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["asalSchemes"],
  }));
  const navigate = useNavigate();
  const DescriptionPanel = ({ text }) => {
    const [expanded, setExpanded] = useState(false);
    const maxHeight = "4.5rem";

    return (
      <div>
        <div
          style={{
            maxHeight: expanded ? "none" : maxHeight,
            overflow: "hidden",
            position: "relative",
            whiteSpace: "pre-wrap",
          }}
        >
          {text || "N/A"}
        </div>
        {text?.length > 120 && (
          <div className="mt-1">
            <button
              onClick={() => setExpanded(!expanded)}
              className="py-1 cursor-pointer text-darkBlue font-interSans text-[.875rem] font-[500] underline gap-x-[.5rem] flex items-center"
            >
              {expanded ? (
                <span className="flex items-center gap-1 text-darkBlue font-interSans text-[.875rem] font-[500] hover:underline">
                  View Less
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.99941 4.58164C7.84941 4.58164 7.72441 4.63164 7.59941 4.73164L1.84941 10.3816C1.62441 10.6066 1.62441 10.9566 1.84941 11.1816C2.07441 11.4066 2.42441 11.4066 2.64941 11.1816L7.99941 5.95664L13.3494 11.2316C13.5744 11.4566 13.9244 11.4566 14.1494 11.2316C14.3744 11.0066 14.3744 10.6566 14.1494 10.4316L8.39941 4.78164C8.27441 4.65664 8.14941 4.58164 7.99941 4.58164Z"
                      fill="#0092CC"
                    />
                  </svg>
                </span>
              ) : (
                <span className="flex items-center gap-1 text-darkBlue font-interSans text-[.875rem] font-[500] hover:underline">
                  View More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="7"
                    viewBox="0 0 14 7"
                    fill="none"
                  >
                    <path
                      d="M6.99999 6.90078C6.84999 6.90078 6.72499 6.85078 6.59999 6.75078L0.849994 1.10078C0.624994 0.875781 0.624994 0.525781 0.849994 0.300781C1.07499 0.0757814 1.42499 0.0757814 1.64999 0.300781L6.99999 5.52578L12.35 0.250781C12.575 0.0257812 12.925 0.0257812 13.15 0.250781C13.375 0.475781 13.375 0.825781 13.15 1.05078L7.39999 6.70078C7.27499 6.82578 7.14999 6.90078 6.99999 6.90078Z"
                      fill="#0092CC"
                    />
                  </svg>
                </span>
              )}
            </button>
          </div>
        )}
      </div>
    );
  };
  const items1 = [
    {
      key: "1",
      label: "Scheme Name",
      children: activeObjSchemes?.schName ?? "N/A",
    },
    {
      key: "2",
      label: "Scheme Type",
      children: activeObjSchemes?.schSchemeType ?? "N/A",
    },
    {
      key: "3",
      label: "Scheme Size",
      children: activeObjSchemes?.schSize ?? "N/A",
    },
    {
      key: "4",
      label: "Description",
      children: <DescriptionPanel text={activeObjSchemes?.schDesc} />,
    },
    {
      key: "5",
      label: "Status",
      children: activeObjSchemes?.schStatus ?? "N/A",
    },
    {
      key: "6",
      label: "County",
      children: activeObjSchemes?.schCountyName ?? "N/A",
    },
    {
      key: "7",
      label: "Subcounty",
      children: activeObjSchemes?.schSubCountyName ?? "N/A",
    },
    {
      key: "8",
      label: "Location",
      children: activeObjSchemes?.schLocationName ?? "N/A",
    },
    {
      key: "8",
      label: "SubLocation",
      children: activeObjSchemes?.schLocationName ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: activeObjSchemes?.schConstituency ?? "N/A",
    },
    {
      key: "55",
      label: "Ward",
      children: activeObjSchemes?.schWard ?? "N/A",
    },
    {
      key: "9",
      label: "Latitudes",
      children: activeObjSchemes?.schLat ?? "N/A",
    },
    {
      key: "10",
      label: "Longitudes",
      children: activeObjSchemes?.schLong ?? "N/A",
    },

    {
      key: "12",
      label: "Scheme Registered IWUA?",
      children: activeObjSchemes?.schHaveIwua ?? "N/A",
    },
    {
      key: "13",
      label: "IWUA Contact Person",
      children: activeObjSchemes?.schContactPerson ?? "N/A",
    },
    {
      key: "14",
      label: "Phone of Contact Person",
      children: activeObjSchemes?.schContactPhone ?? "N/A",
    },
    {
      key: "15",
      label: "Position of Contact Person",
      children: activeObjSchemes?.schContactPosition ?? "N/A",
    },
    {
      key: "16",
      label: "Major Crop",
      children: activeObjSchemes?.schCrops ?? "N/A",
    },
    {
      key: "16",
      label: "Irrigation License",
      children: (
        <div
          className="cursor-pointer text-darkBlue underline"
          onClick={() => previewPaper(activeObjSchemes?.schIrrLicense)}
        >
          {formatPath(activeObjSchemes?.schIrrLicense)}
        </div>
      ),
    },
  ];

  const items2 = [
    {
      key: "1",
      label: "Responsible Agency",
      children: activeObjSchemes?.schAgency ?? "N/A",
    },
    {
      key: "2",
      label: "Construction Start Date",
      children: (
        <div>
          {activeObjSchemes?.schConstructionStartDate
            ? moment(activeObjSchemes?.schConstructionStartDate)?.format(
                "DD-MM-YYYY"
              )
            : "--"}
        </div>
      ),
    },
    {
      key: "3",
      label: "Construction End Date",
      children: (
        <div>
          {activeObjSchemes?.schConstructionEndDate
            ? moment(activeObjSchemes?.schConstructionEndDate)?.format(
                "DD-MM-YYYY"
              )
            : "--"}
        </div>
      ),
    },
    {
      key: "4",
      label: "Revised Date",
      children: (
        <div>
          {activeObjSchemes?.schRevisedEndDate
            ? moment(activeObjSchemes?.schRevisedEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "5",
      label: "Mode of Funding",
      children: activeObjSchemes?.schFundingMode ?? "N/A",
    },
    {
      key: "6",
      label: "Source of Funding",
      children: activeObjSchemes?.schFundSource ?? "N/A",
    },
    {
      key: "7",
      label: "Intial Project Cost",
      children: (
        <div>{cashConverter(activeObjSchemes?.schInitialExpenditure)}</div>
      ),
    },
    {
      key: "8",
      label: "Actual Project Cost",
      children: (
        <div>{cashConverter(activeObjSchemes?.schActualExpenditure)}</div>
      ),
    },
    {
      key: "8",
      label: "O&M cost per Month",
      children: (
        <div>{cashConverter(activeObjSchemes?.schOperationalMaintenance)}</div>
      ),
    },
  ];

  const items3 = [
    {
      key: "2",
      label: "Irrigated Area",
      children: (
        <div>
          {activeObjSchemes?.schIrrigationArea
            ? `${activeObjSchemes?.schIrrigationArea} Acre`
            : "N/A"}
        </div>
      ),
    },
    {
      key: "3",
      label: "Potential Size",
      children: activeObjSchemes?.schPotentialSize ?? "N/A",
    },
    {
      key: "4",
      label: "Land Use",
      children: activeObjSchemes?.schLandUse ?? "N/A",
    },
    {
      key: "5",
      label: "Average household income before",
      children: activeObjSchemes?.schAverageHouseHoldIncomeBefore ?? "N/A",
    },
    {
      key: "6",
      label: "Average household income after",
      children: activeObjSchemes?.schAverageHouseHoldIncomeAfter ?? "N/A",
    },
    {
      key: "7",
      label: "Number of households",
      children: activeObjSchemes?.schHouseholdNo ?? "N/A",
    },
    {
      key: "8",
      label: "Number of farmers",
      children: activeObjSchemes?.schFarmersNumber ?? "N/A",
    },
    {
      key: "9",
      label: "Number of staff employed by scheme",
      children: activeObjSchemes?.schStaffEmployedNumber ?? "N/A",
    },
    {
      key: "10",
      label: "Blocks",
      children: activeObjSchemes?.schBlocks ?? "N/A",
    },
  ];
  const items4 = [
    {
      key: "1",
      label: "Irrigation TYpe",
      children: activeObjSchemes?.schIrrigationType ?? "N/A",
    },

    {
      key: "2",
      label: "Source of water",
      children: activeObjSchemes?.schWaterSource ?? "N/A",
    },
    {
      key: "3",
      label: "Design Capacity",
      children: activeObjSchemes?.schDesignCapacity ?? "N/A",
    },
    {
      key: "4",
      label: "Is water adequate",
      children: activeObjSchemes?.schIsWaterAdequate ?? "N/A",
    },
    {
      key: "5",
      label: "Do you have water abstraction permit",
      children: activeObjSchemes?.schAbsPermit ?? "N/A",
    },
    {
      key: "6",
      label: "Water storage available",
      children: activeObjSchemes?.schIsWaterStorageAvailable ?? "N/A",
    },
    {
      key: "7",
      label: "Water storage capacity",
      children: activeObjSchemes?.schWaterStorageCapacity ?? "N/A",
    },
    {
      key: "8",
      label: "Mode of water abstraction",
      children: activeObjSchemes?.schWaterAbstractionModeName ?? "N/A",
    },

    {
      key: "10",
      label: "Means of conveying water",
      children: activeObjSchemes?.schWaterConveyingMeansName ?? "N/A",
    },

    {
      key: "12",
      label: "Modes of water application",
      children: activeObjSchemes?.schWaterApplicationModesName ?? "N/A",
    },
    {
      key: "13",
      label: "Pathways",
      children: activeObjSchemes?.schPathways ?? "N/A",
    },
    {
      key: "14",
      label: "Abstraction Permit File",
      children: (
        <div
          className="cursor-pointer text-darkBlue underline"
          onClick={() => previewPaper(activeObjSchemes?.schPermitFile)}
        >
          {formatPath(activeObjSchemes?.schPermitFile)}
        </div>
      ),
    },
    {
      key: "15",
      label: "Meter Type",
      children: activeObjSchemes?.schWaterMeterType ?? "N/A",
    },
  ];

  const [more, setMore] = useState(false);
  const handleViewMore = () => {
    setMore(!more);
  };
  const [column, setColumn] = useState(2);
  const [labelStyle, setLabelStyle] = useState(250);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setColumn(1);
        setLabelStyle(150);
      } else if (width < 1024) {
        setColumn(2);
        setLabelStyle(250);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="white_card mt-[1.75rem]">
      <div className="custom-title">Scheme Details</div>
      <div className="flex items-start lg:flex-row flex-col gap-[1.25rem] w-full">
        <div className="lg:w-[40%] w-full">
          <Descriptions
            column={1}
            colon={true}
            items={items1}
            labelStyle={{ width: 180 }}
          />
        </div>
        <div className="lg:w-[60%] w-full">
          {" "}
          <LeafletMap />
        </div>
      </div>
      <div
        className="py-[2rem] cursor-pointer text-darkBlue font-interSans text-[.875rem] font-[500] underline gap-x-[.5rem] flex items-center"
        onClick={handleViewMore}
      >
        {more ? "View Less" : "View More"}
        {more ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99941 4.58164C7.84941 4.58164 7.72441 4.63164 7.59941 4.73164L1.84941 10.3816C1.62441 10.6066 1.62441 10.9566 1.84941 11.1816C2.07441 11.4066 2.42441 11.4066 2.64941 11.1816L7.99941 5.95664L13.3494 11.2316C13.5744 11.4566 13.9244 11.4566 14.1494 11.2316C14.3744 11.0066 14.3744 10.6566 14.1494 10.4316L8.39941 4.78164C8.27441 4.65664 8.14941 4.58164 7.99941 4.58164Z"
              fill="#0092CC"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="7"
            viewBox="0 0 14 7"
            fill="none"
          >
            <path
              d="M6.99999 6.90078C6.84999 6.90078 6.72499 6.85078 6.59999 6.75078L0.849994 1.10078C0.624994 0.875781 0.624994 0.525781 0.849994 0.300781C1.07499 0.0757814 1.42499 0.0757814 1.64999 0.300781L6.99999 5.52578L12.35 0.250781C12.575 0.0257812 12.925 0.0257812 13.15 0.250781C13.375 0.475781 13.375 0.825781 13.15 1.05078L7.39999 6.70078C7.27499 6.82578 7.14999 6.90078 6.99999 6.90078Z"
              fill="#0092CC"
            />
          </svg>
        )}
      </div>
      {more && (
        <div className="w-full flex-col">
          <div className="custom-title">Operational information</div>
          <Descriptions
            column={column}
            colon={true}
            items={items2}
            labelStyle={{ width: 180 }}
          />
          <div className="custom-title mt-[3.25rem]">Land and Use</div>
          <Descriptions
            column={column}
            colon={true}
            items={items3}
            labelStyle={{ width: labelStyle }}
          />
          <div className="custom-title mt-[3.25rem]">Water</div>
          <Descriptions
            column={column}
            colon={true}
            items={items4}
            labelStyle={{ width: labelStyle }}
          />
        </div>
      )}
    </div>
  );
}

export default AboutScheme;
